/*
	Licznik znaków pod polem wiadomości („0/1000" z makiety).

	W projekcie bazowym jest już `assets/admin/js/letters-left.js`, ale to widżet panelu
	i pokazuje „Pozostało znaków: N" — makieta chce zapisu `użyte/limit`, więc frontend
	dostaje własny, mniejszy licznik.

	Podpina się do każdego pola z `data-char-counter` i `maxlength`.
*/

const SELECTOR = '[data-char-counter][maxlength]';

const mount = (field) => {
	const max = parseInt(field.getAttribute('maxlength'), 10);
	if (!max) {
		return;
	}

	const counter = document.createElement('div');
	counter.className = 'char-counter';

	const render = () => {
		counter.textContent = `${field.value.length}/${max}`;
	};

	field.insertAdjacentElement('afterend', counter);
	field.addEventListener('input', render);
	render();
};

document.querySelectorAll(SELECTOR).forEach(mount);
